<template>
  <SectionPage :img="img" :content="content" :btn="btn" :icon="icon"/>
</template>

<script>
import SectionPage from '@/layout/SectionPage.vue'
export default {
  name: "Section4",
  components: {
    SectionPage
  },
  data() {
    return {
      img: require('@/assets/section-bg/section4.jpg'),
      content: {
        componentsType: {
          pc: 'shortBtn sectionBtn',
          mobile: 'shortBtn sectionBtn'
        },
        title: '04\nPHYSICAL CONDITION',
        text: 'Let us know your physical condition, we can better avoid some possible sources of allergy.'
      },
      btn:{
        text: 'Next',
        link: '/questionnaire/section4/1',
      },
      icon: require('@/assets/icon/section-04.png')
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
